import { h } from 'preact';

export const SignUpIcon = () => (
	<svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M21 26.4238C27.5642 26.4238 33.2662 30.151 36.0755 35.6026C39.747 31.8199 42 26.6742 42 21C42 9.40132 32.5987 0 21 0C9.40132 0 0 9.40132 0 21C0 26.6742 2.25298 31.8199 5.9245 35.6026C8.73378 30.151 14.4358 26.4238 21 26.4238Z"
			fill="#9EB35E"
		/>
		<path
			d="M21.0003 42C26.9248 42 32.2652 39.5523 36.0758 35.6026C33.2665 30.151 27.5645 26.4238 21.0003 26.4238C14.4361 26.4238 8.73408 30.151 5.9248 35.6026C9.7354 39.5523 15.0758 42 21.0003 42Z"
			fill="#131410"
		/>
		<path
			d="M21 24.4767C25.6853 24.4767 29.4835 20.6785 29.4835 15.9932C29.4835 11.3079 25.6853 7.50977 21 7.50977C16.3148 7.50977 12.5166 11.3079 12.5166 15.9932C12.5166 20.6785 16.3148 24.4767 21 24.4767Z"
			fill="#131410"
		/>
	</svg>
);

